import { ProgressSpinner } from 'primereact/progressspinner'
import React from 'react'

const Loading = (props:any) => {
  return (
    <div  className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }} {...props}>
          <ProgressSpinner 
            style={{width: '50px', height: '50px'}} 
            strokeWidth="4"
            fill="black"
            animationDuration=".5s"
          />
    </div>
  )
}

export default Loading

